import React, { useState } from "react";
// import ShortDisplayReview from "./ShortDisplayReview";
import Rating from "@mui/material/Rating";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Stack from "@mui/material/Stack";
import "./review.css";

const ReviewFullAndAddNew = ({ review, isShowReview, setIsShowReview }) => {
//   console.log(reviews);

const formatDate = {month: "long", day: "numeric"};
  return (
    <div
      className={`fixed-full-review ${
        isShowReview && "show-fixed-full-review"
      }`}
    >
      <button
        onClick={() => setIsShowReview(false)}
        className="button-review-close "
      >
        <AiOutlineCloseCircle className="btn-close-cart-ani" />
      </button>
      <h4 className="review-rating-section-title">Product Reviews</h4>
      <section className="review-read-fixed-height">
        <article className="review-flex-all-users">
          {review?.length !== 0 ? (
            review?.map((review, index) => {
              const { userName, rating, comment, createdAt } = review;
              return (
                <div className="comment-container" key={index}>
                  <div className="review-read-heading">
                    <p className="icon-reviewer-name-p">
                      {userName?.slice(0, 2).toUpperCase()}
                    </p>
                    <div>
                      <h5>{userName}</h5>
                      <Stack spacing={1}>
                        <Rating
                          name="half-rating-read"
                          value={rating}
                          precision={0.5}
                          readOnly
                          sx={{ fontSize: "14px" }}
                        />
                      </Stack>
                      <span style={{ fontSize: "12px", color: "gray" }}>
                        {new Date(createdAt).toLocaleDateString("en-US",formatDate)}
                      </span>
                    </div>
                  </div>
                  <p className="review-description">{comment}</p>
                </div>
              );
            })
          ) : (
            <h1
              style={{
                color: "white",
                textAlign: "center",
                fontWeight: "bolder",
              }}
            >
              No Review To Display
            </h1>
          )}
        </article>
      </section>
    </div>
  );
};

export default ReviewFullAndAddNew;
